
export default function Subtitle({ title }) {
    return (
        <div className="text-3xl md:text-4xl font-bold">
            {title}
        </div>
    );
}
